var storage = {};

export default {
    data : {
      yesno: "Yes,No",
      conf: "Confirmed",
      done: "Succes",
      mandatory: "This field is mandatory.",
      total: "Total",
      butSearch: "Search",
      butAdd: "Add",
      butSave: "Save",
      butCancel: "Cancel",
      butReturn: "Return",
      searchHolder: "Searching for...",

      sdelM: "Are you sure to delete {1} '{2}' ?",
      sdelT:"Delete {1}",
    
      addM: "Add {1}",
      modM: "Modify {1} : '{2}'",
    
      addOK: "{1} with code '{2}' is added.",
      modOK: "{1} with code '{2}' is modified.",
      delOK: "{1} with code '{2}' is deleted."
    },
    
    getText: function(id,var1,var2,var3) {
      let txt = this.data[id];
      return txt.replace("{1}",var1).replace("{2}",var2).replace("{3}",var3);
    }
    
}



// WEBPACK FOOTER //
// ./src/common/AppText.js